export default "__VITE_ASSET__CsPaVZjK__"